module.exports = __webpack_public_path__ + "img/dText.bda276fa.svg";